/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Last_Bill_Detail_MessagesInputs */

const es_admin_billing_last_bill_detail_messages = /** @type {(inputs: Admin_Billing_Last_Bill_Detail_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensajes`)
};

const en_admin_billing_last_bill_detail_messages = /** @type {(inputs: Admin_Billing_Last_Bill_Detail_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages`)
};

/**
* | output |
* | --- |
* | "Messages" |
*
* @param {Admin_Billing_Last_Bill_Detail_MessagesInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_last_bill_detail_messages = /** @type {((inputs?: Admin_Billing_Last_Bill_Detail_MessagesInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Last_Bill_Detail_MessagesInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_last_bill_detail_messages(inputs)
	return en_admin_billing_last_bill_detail_messages(inputs)
});
export { admin_billing_last_bill_detail_messages as "admin.billing.last_bill.detail_messages" }